/**
 * @description: 商品赠送明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-szm-report">
        <div class="szm-list">
            <p class="p-hint">注：赠送总量和赠送金额已扣除退款商品和退款金额</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="szmTime">
                        <input type="text" class="form-control laydate-icon" v-model="szmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="szmEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="szm_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择商品类型" v-model="gtype_txt" ref="gtype_txt" @click="gtypeFun($event)" readonly>
                    <span class="selection-clear" @click="clear_input('gtype_txt')">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="szm_name">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">赠送人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择商品类型" ref="szm_user"></select>
                </div>
                <label class="list-label-4">预订人:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入预订人" v-model="szm_book_admin_name">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitSzmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getSzmExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-6">赠送数量合计:</label>
                <div class="list-total" ref="szm_total"></div>
                <label class="list-label-6">赠送金额合计:</label>
                <div class="list-total" ref="szm_amount"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="szmList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="szmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='szmExport_allcheck' @click='szmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="timestamp">
                            <label>赠送时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="room_name">
                            <label>赠送包厢</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="book_admin_name">
                            <label>预订人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="admin_name">
                            <label>赠送人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="actual_amount">
                            <label>销售单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="quantity">
                            <label>赠送数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="total_amount">
                            <label>赠送金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szmExport_checkModel' value="buying_price_total">
                            <label>进货价总额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='szmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='szmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 商品类型弹窗 -->
        <div class="ele-hide" ref="gtype_area">
            <div class="set-export sel-seldiv">
                <ul class="set-area clearfix">
                    <li>
                        <input type='checkbox' v-model='gtype_all' @click='gtypeAll'>
                        <label>全选</label>
                    </li>
                    <li v-for="item in gtype_data" :key="item.id">
                        <input type="checkbox" v-model='gtype_item' :value="item.id">
                        <label>{{item.name}}</label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                szmStartTime: "",
                szmEndTime: "",
                szm_name: "",
                szm_book_admin_name: "",
                szm_list_total: "0",
                gtype_txt: '',
                gtype_all: false,
                c_gtype_all: false,
                gtype_data: [],
                gtype_item: [],
                szmExport_allcheck: false,
                c_szmExport_allcheck: false,
                szmExport_checkModel: [],
                szmExport_checkData: ['timestamp', 'room_name', 'book_admin_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'admin_name', 'actual_amount', 'quantity', 'total_amount', 'buying_price', 'buying_price_total'],
                szmExport_type: 1,
            }
        },
        watch: {
            gtype_txt: {
                handler: function(val,oldval) {
                    if(val != "") {
                        $(this.$refs.gtype_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.gtype_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            gtype_item: {
                handler: function (val, oldVal) {
                    if(this.gtype_item.length >= this.gtype_data.length) {
                        this.gtype_all = true;
                        this.c_gtype_all = true;
                    } else {
                        this.gtype_all = false;
                        this.c_gtype_all = false;
                    }
                },
                deep: true
            },
            szmExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.szmExport_checkModel.length >= this.szmExport_checkData.length) {
                        this.szmExport_allcheck = true;
                        this.c_szmExport_allcheck = true;
                    } else {
                        this.szmExport_allcheck = false;
                        this.c_szmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.szmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.szmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.getGoodsType();  // 商品类型
            this.getSzmAdmin()
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.szmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.szmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.szmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.szmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.szmTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.szmStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.szmEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.szm_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.szm_shop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitSzmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 商品类型
            getGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "show_room_pack": -1
                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getAllGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.gtype_data = data.response.result.data
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取赠送人数据
            getSzmAdmin: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let szmAdmDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                szmAdmDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.szm_user).html("");
                            $(_this.$refs.szm_user).select2({
                                data: szmAdmDatas,
                                language: "zh-CN",
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 商品类型弹窗
            gtypeFun: function(e) {
                let _this = this;
                let c_gtype_item = _this.gtype_item;
                layer.confirm('', {
                    skin: 'timing_room_type',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['商品类型', true],
                    area: ['660px', ''], // 宽高
                    content: $(_this.$refs.gtype_area),
                    cancel: function() {
                        // 右上角关闭
                        _this.gtype_item = c_gtype_item;
                    }
                }, function() {
                    let texts = [];
                    _this.gtype_data.forEach(function(item) {
                        _this.gtype_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.gtype_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    _this.gtype_item = c_gtype_item;
                });
            },

            // 全选
            gtypeAll: function() {
                let _this = this;
                _this.gtype_all = _this.c_gtype_all;
                if(!_this.gtype_all) { // 实现全选
                    _this.gtype_item = [];
                    _this.gtype_data.forEach(function(item) {
                        _this.gtype_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.gtype_item = [];
                }
            },

            // 清空多选
            clear_input: function(name) {
                if(name == 'gtype_txt') {
                    this.gtype_txt = "";
                    this.gtype_item = [];
                }
            },

            // 表格
            innitSzmTable: function() {
                let _this = this;
                $(_this.$refs.szmList).bootstrapTable('destroy');
                $(_this.$refs.szmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSzmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "timestamp",
                        title: "赠送时间",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "room_name",
                        title: "赠送包厢",
                        width: "6%",
                        valign: "middle"
                    },{
                        field: "book_admin_name",
                        title: "预订人",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "8%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "admin_name",
                        title: "赠送人",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "actual_amount",
                        title: "销售单价",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "赠送数量",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "total_amount",
                        title: "赠送金额",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "buying_price_total",
                        title: "进货价总额",
                        width: "6%",
                        valign: "middle"
                    }],
                });
            },
            getSzmList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.szmStartTime,
                            "end_time": _this.szmEndTime,
                            "shop_id": $(_this.$refs.szm_shop).val(),
                            "goods_type": _this.gtype_item,
                            "goods_name": _this.szm_name,
                            "admin_id": $.trim($(_this.$refs.szm_user).val()),
                            "book_admin_name": _this.szm_book_admin_name,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + 'FinanceReport2/getGiftDetailReport',
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(pageNumber == 1) {
                                _this.szm_list_total = data.response.result.total;
                                $(_this.$refs.szm_total).text(data.response.result.total_quantity);
                                $(_this.$refs.szm_amount).text(data.response.result.total_amount);
                            }
                            params.success({
                                total: _this.szm_list_total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getSzmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/giftDetailReportExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.szmExport_checkModel = data.response.result.export_fields;
                                _this.szmExport_type = data.response.result.export_type;
                            } else {
                                _this.szmExport_checkModel = _this.szmExport_checkData;
                                _this.szmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.szmExport_alert)
                }, function() {
                    _this.exportSzmList();
                });
            },
            // 导出字段全选
            szmExportCheckedAll: function(type) {
                let _this = this;
                _this.szmExport_allcheck = _this.c_szmExport_allcheck;
                if(!_this.szmExport_allcheck) { // 实现全选
                    _this.szmExport_checkModel = [];
                    _this.szmExport_checkData.forEach(function(item) {
                        _this.szmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.szmExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportSzmList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.szmExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/giftDetailReportExport" +
                    "?start_time=" + _this.szmStartTime +
                    "&end_time=" + _this.szmEndTime +
                    "&shop_id=" + $(_this.$refs.szm_shop).val() +
                    "&goods_type=" + _this.gtype_item +
                    "&goods_name=" + _this.szm_name +
                    "&admin_id=" + $.trim($(_this.$refs.szm_user).val()) +
                    "&book_admin_name=" + _this.szm_book_admin_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.szmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>